import celenoraLogo from "../../../assets/celenora-logo.svg";
import fullLogo from "../../../assets/full-logo.svg";
import "./LogoAnimationComponent.scss";

export function LogoAnimationComponent() {
  return (
    <div className="logo-container flex-column justify-content-center">
      <img className="celenora-logo" src={celenoraLogo} />
      <img className="full-logo" src={fullLogo} />
    </div>
  );
}
